import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let AllMainPagesSectionThunk = createAsyncThunk(
  "pages/AllMainPagesSectionThunk",
  async (arg, ThunkApi) => {
    let { rejectWithValue } = ThunkApi;
    try {
      let url = `api/main_page`;

      let res = await axios.get(url);

      return res.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
